import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import ImageWithBasePath from "../../img/imagewithbasebath";
import PropTypes from "prop-types";
import { createSupplier, getSupplier, updateSupplier } from "../../../service/ApiServices";
import Swal from "sweetalert2";
const SupplierModal = ({onSupplierAdded, supplierId}) => {
  const [formData, setFormData] = useState({
    supplierName: "",
    supplierEmail: "",
    supplierPhone: "",
    supplierAddress: "",
    supplierCity: "",
    supplierCountry: "",
    supplierDescription: "",
    supplierImage: null,

  });

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const username = userData?.data.name;


  const [previewUrl, setPreviewUrl] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        supplierImage: file,
      });

      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // console.log(CustomerModal)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const setSelectedSupplier = async (supplierId) => {
    try {
      const response = await getSupplier(supplierId);
      if (response.data) {
        const { supplierName, supplierEmail, supplierPhone, supplierAddress, supplierCity, supplierCountry, supplierDescription, supplierImage,lastEditedAt,lastEditedBy } = response.data.data.supplier;
        setFormData({
          supplierName,
          supplierEmail,
          supplierPhone,
          supplierAddress,
          supplierCity,
          supplierCountry,
          supplierDescription,
          supplierImage,
          lastEditedAt,
          lastEditedBy
        });
        // Set preview URL for existing image
        if (supplierImage) {
          setPreviewUrl(supplierImage);
        }
      } else {
        console.error("Failed to fetch Supplier data");
      }
    } catch (error) {
      console.error("Error fetching Supplier data:", error);
    }
  };

  useEffect(() => {
    if (supplierId) {
      setSelectedSupplier(supplierId);
    }
  }, [supplierId]);

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      
      // Append all form fields to FormData
      Object.keys(formData).forEach(key => {
        if (key === 'supplierImage' && formData[key] instanceof File) {
          formDataToSend.append('supplierImage', formData[key]);
        } else if (key !== 'supplierImage') {
          formDataToSend.append(key, formData[key]);
        }
      });
      formDataToSend.append('userName',username)

      await updateSupplier(supplierId, formDataToSend);
      onSupplierAdded();
      handleCancel();
      Swal.fire({
        title: "success!",
        text: "Supplier Update Sucessfully",
        icon: "success",
      });
    } catch (error) {
      console.error("Error updating supplier:", error);
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
      });
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      
      // Append all form fields to FormData
      Object.keys(formData).forEach(key => {
        if (key === 'supplierImage' && formData[key] instanceof File) {
          formDataToSend.append('supplierImage', formData[key]);
        } else if (key !== 'supplierImage') {
          formDataToSend.append(key, formData[key]);
        }
      });

       await createSupplier(formDataToSend);
      onSupplierAdded();
      //console.log("Supplier added successfully:", response.data);
      handleCancel();
      Swal.fire({
        title: "success!",
        text: "Supplier Added Sucessfully",
        icon: "success",
      });
    } catch (error) {
      console.error("Error adding supplier:", error);
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
      });
    }
  };

  const handleCancel = ()=>{
    setFormData({
        supplierName: "",
        supplierEmail: "",
        supplierPhone: "",
        supplierAddress: "",
        supplierCity: "",
        supplierCountry: "",
        supplierDescription: "",
        supplierImage: null,
      });
    setPreviewUrl(null);
  }
  // const options3 = [{ value: "Varrel", label: "Varrel" }];

  // const options4 = [
  //   { value: "Germany", label: "Germany" },
  //   { value: "France", label: "France" },
  //   { value: "Mexico", label: "Mexico" },
  // ];
  return (
    <div>
      {/* Add Supplier */}
      <div className="modal fade" id="add-units" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          {/* <div className="profile-pic-upload mb-2">
                            <div className="profile-pic">
                              <span>
                                <i
                                  data-feather="plus-circle"
                                  className="plus-down-add"
                                />{" "}
                                Profile Photo
                              </span>
                            </div>
                            <div className="input-blocks mb-0">
                              <div className="image-upload mb-0">
                                <input type="file" />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div> */}
                            <div className="profile-pic-upload">
                              <div className="profile-pic" style={{ 
                                backgroundImage: `url(${previewUrl || (formData.supplierImage || '')})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                              }}>
                                {!previewUrl && !formData.supplierImage && (
                                  <span>
                                    <i data-feather="plus-circle" className="plus-down-add" /> Add
                                    Image
                                  </span>
                                )}
                              </div>
                            <div className="mb-3">
                              <div className="image-upload mb-0">
                                <input 
                                  type="file" 
                                  onChange={handleImageChange}
                                  accept="image/*"
                                />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Supplier Name</label>
                          <input type="text"
                            className="form-control"
                            name="supplierName"
                            value={formData.supplierName}
                            onChange={handleChange} 
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Email</label>
                          <input type="text"
                            className="form-control"
                            name="supplierEmail"
                            value={formData.supplierEmail}
                            onChange={handleChange} 
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Phone</label>
                          <input name="supplierPhone"
                            type="text"
                            value={formData.supplierPhone}
                            onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>Address</label>
                          <input type="text"
                            className="form-control"
                            name="supplierAddress"
                            value={formData.supplierAddress}
                            onChange={handleChange} 
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>City</label>
                          {/* <Select className="select" options={options1} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCity"
                            value={formData.supplierCity}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>Country</label>
                          {/* <Select className="select" options={options2} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCountry"
                            value={formData.supplierCountry}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0 input-blocks">
                          <label className="form-label">Descriptions</label>
                          {/* <textarea
                            className="form-control mb-1"
                            defaultValue={""}
                          /> */}
                          <textarea
                            className="form-control mb-1"
                            name="supplierDescription"
                            value={formData.supplierDescription}
                            onChange={handleChange}
                            required
                          />
                          <p>Maximum 600 Characters</p>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={()=>{handleCancel()}}
                      >
                        Cancel
                      </button>
                      <button type="submit"
                        className="btn btn-submit"
                        data-bs-dismiss="modal">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Supplier */}
      {/* Edit Supplier */}
      <div className="modal fade" id="edit-units" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleUpdateSubmit}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          <div className="profile-pic-upload edit-pic">
                            {/* <div className="profile-pic">
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/supplier/edit-supplier.jpg"
                                  alt
                                />
                              </span>
                              <div className="close-img">
                                <i data-feather="x" className="info-img" />
                              </div>
                            </div> */}
                            <div className="profile-pic" style={{ 
                              backgroundImage: `url(${previewUrl || (formData.supplierImage || '')})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center'
                            }}>
                              {!previewUrl && !formData.supplierImage && (
                                <span>
                                  <i data-feather="plus-circle" className="plus-down-add" /> Add
                                    Image
                                </span>
                              )}
                            </div>
                            {/* <div className="input-blocks mb-0">
                              <div className="image-upload mb-0">
                                <input type="file" />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div> */}
                            <div className="mb-3">
                              <div className="image-upload mb-0">
                                <input 
                                  type="file" 
                                  onChange={handleImageChange}
                                  accept="image/*"
                                />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Supplier Name</label>
                          <input type="text"
                            className="form-control"
                            name="supplierName"
                            value={formData.supplierName}
                            onChange={handleChange}
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Email</label>
                          <input type="text"
                            className="form-control"
                            name="supplierEmail"
                            value={formData.supplierEmail}
                            onChange={handleChange}
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Phone</label>
                          <input name="supplierPhone"
                            type="text"
                            value={formData.supplierPhone}
                            onChange={handleChange} />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>Address</label>
                          <input type="text"
                            className="form-control"
                            name="supplierAddress"
                            value={formData.supplierAddress}
                            onChange={handleChange}
                            required
                            />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>City</label>
                          {/* <Select className="select" options={options3} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCity"
                            value={formData.supplierCity}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>Country</label>
                          {/* <Select className="select" options={options4} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCountry"
                            value={formData.supplierCountry}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="mb-0 input-blocks">
                        <label className="form-label">Descriptions</label>
                        {/* <textarea
                          className="form-control mb-1"
                          defaultValue={""}
                        /> */}
                        <textarea
                            className="form-control mb-1"
                            name="supplierDescription"
                            value={formData.supplierDescription}
                            onChange={handleChange}
                            required
                          />
                        <p>Maximum 600 Characters</p>
                      </div>
                    </div>
                    {formData && formData.lastEditedAt && (
                        <div className="row">
                          <div className="col-12 mt-3">
                            <div className="alert alert-info" role="alert">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <strong>Last Edited:</strong>{" "}
                                  {new Date(formData.lastEditedAt).toLocaleString()}
                                </div>
                                <div>
                                  <strong>Edited By:</strong>{" "}
                                  {formData.lastEditedBy || ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={()=>{handleCancel()}}
                      >
                        Cancel
                      </button>
                      <button type="submit"
                        className="btn btn-submit"
                        data-bs-dismiss="modal">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Supplier */}
      {/*View Supplier */}
      <div className="modal fade" id="view-units" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>View Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          <div className="profile-pic-upload edit-pic">
                            
                          <div className="profile-pic" style={{ 
                            backgroundImage: `url(${formData.supplierImage || ''})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                          }}>
                              
                            </div>
                            
                            
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Supplier Name</label>
                          <input type="text"
                            className="form-control"
                            name="supplierName"
                            value={formData.supplierName}
                           
                            
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Email</label>
                          <input type="text"
                            className="form-control"
                            name="supplierEmail"
                            value={formData.supplierEmail}
                            
                            />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="input-blocks">
                          <label>Phone</label>
                          <input name="supplierPhone"
                            type="text"
                            value={formData.supplierPhone}
                             />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>Address</label>
                          <input type="text"
                            className="form-control"
                            name="supplierAddress"
                            value={formData.supplierAddress}
                            
                            />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>City</label>
                          {/* <Select className="select" options={options3} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCity"
                            value={formData.supplierCity}
                            
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>Country</label>
                          {/* <Select className="select" options={options4} /> */}
                          <input
                            type="text"
                            className="form-control"
                            name="supplierCountry"
                            value={formData.supplierCountry}
                           
                          />
                        </div>
                      </div>
                      <div className="mb-0 input-blocks">
                        <label className="form-label">Descriptions</label>
                        {/* <textarea
                          className="form-control mb-1"
                          defaultValue={""}
                        /> */}
                        <textarea
                            className="form-control mb-1"
                            name="supplierDescription"
                            value={formData.supplierDescription}
                            
                          />
                        <p>Maximum 600 Characters</p>
                      </div>
                    </div>
                    {formData && formData.lastEditedAt && (
                        <div className="row">
                          <div className="col-12 mt-3">
                            <div className="alert alert-info" role="alert">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <strong>Last Edited:</strong>{" "}
                                  {new Date(formData.lastEditedAt).toLocaleString()}
                                </div>
                                <div>
                                  <strong>Edited By:</strong>{" "}
                                  {formData.lastEditedBy || ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        
                      >
                        Cancel
                      </button>
                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
SupplierModal.propTypes = {
  onSupplierAdded: PropTypes.func.isRequired,
  supplierId: PropTypes.string.isRequired,
};

export default SupplierModal;
